import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation, useQueryClient } from "react-query";

const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function ModalCancelUploaderImage(props: any) {
    const [open, setOpen] = React.useState<boolean>(props.openModal);
    React.useEffect(() => {
        setOpen(props.openModal);
    }, [props.openModal]);

    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    const queryClient = useQueryClient();


    const handelVerify = () => {
        props.setValue();
        handleClose();
    };
    const handelCancel = () => {
        handleClose();
    };

    return (
        <div style={{ width: "100%", height: "100%", display: 'flex' }}>
            <Button
                fullWidth
                onClick={handleOpen}
                style={{ color: 'white', padding: "0px", minWidth: "0px", alignSelf: "center", float: "left" }}
            >
                <DeleteIcon className="deleteIcon" style={{ marginLeft: "5px" }} />
                {props.title ? props.title : ""}
            </Button>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >
                <Box
                    sx={style}
                    style={{ borderRadius: "6px", padding: "40px 70px 70px 60px" }}
                    className="ModalCmp textCenter "
                >
                    <div>
                        <Typography className="textCenter mTop30 mbottom20">
                            آیا از <b className="colorCancel">این عملیات</b> اطمینان دارید؟
                        </Typography>
                    </div>
                    <Grid container spacing={2} columns={16} className="mTop20">
                        <Grid item xs={8}>
                            <Button
                                onClick={handelVerify}
                                fullWidth
                                className="btnForm SuccessDefault"
                            >
                                بله
                            </Button>
                        </Grid>
                        <Grid item xs={8}>
                            <Button
                                onClick={handelCancel}
                                fullWidth
                                className="btnForm DangerDefault"
                            >
                                خیر
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}
